var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tree-table", {
    attrs: { rows: _vm.rows, columns: _vm.columns },
    scopedSlots: _vm._u([
      {
        key: "beforeRows",
        fn: function(scope) {
          return [
            _c("tr", { staticClass: "kt-datatable__row" }, [
              _c("td", { staticClass: "kt-datatable__cell" }, [
                _c("b", [_vm._v(_vm._s(_vm.messages["CATALOG"]))])
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "kt-datatable__cell" }),
              _vm._v(" "),
              _c("td", { staticClass: "kt-datatable__cell" }, [
                _c("div", { staticStyle: { width: "150px" } }, [
                  _c("div", { staticClass: "input-group input-group-sm" }, [
                    _c("input", {
                      ref: "catalogExtra",
                      staticClass: "form-control",
                      attrs: {
                        tabindex: "1",
                        name: "extra_persent",
                        type: "number",
                        value: "0",
                        min: "-100",
                        step: "any"
                      },
                      on: {
                        change: function($event) {
                          return _vm.updateExtra(null, $event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _vm._v("%")
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]
        }
      },
      {
        key: "name",
        fn: function(scope) {
          return [
            _c(
              "div",
              {
                staticStyle: { width: "367px" },
                style: {
                  "padding-left": 25 * (scope.row.DEPTH_LEVEL - 1) + "px"
                }
              },
              [
                (scope.row.CHILDREN || []).length
                  ? _c(
                      "a",
                      {
                        staticClass: "mr-3 collapsed",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return scope.toggleRow(scope.row)
                          }
                        }
                      },
                      [
                        _c("i", {
                          class: {
                            "flaticon2-right-arrow": !scope.row.IS_EXPAND,
                            "flaticon2-down-arrow": scope.row.IS_EXPAND
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v("\n\t\t\t" + _vm._s(scope.row.NAME) + "\n\t\t")
              ]
            )
          ]
        }
      },
      {
        key: "extra",
        fn: function(scope) {
          return [
            _vm._v(
              "\n\t\t" +
                _vm._s((scope.row._EXTRA[_vm.priceId] || {}).VALUE || 0) +
                "%\n\t"
            )
          ]
        }
      },
      {
        key: "edit_extra",
        fn: function(scope) {
          return [
            _c("div", { staticStyle: { width: "150px" } }, [
              _c("div", { staticClass: "input-group input-group-sm" }, [
                _c("input", {
                  staticClass: "form-control",
                  attrs: {
                    tabindex: "1",
                    name: "extra_persent",
                    type: "number",
                    min: "-100",
                    step: "any"
                  },
                  domProps: {
                    value: (scope.row.EXTRA[_vm.priceId] || {}).VALUE
                  },
                  on: {
                    change: function($event) {
                      return _vm.updateExtra(scope.row, $event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-append" }, [
                  _c("span", { staticClass: "input-group-text" }, [_vm._v("%")])
                ])
              ])
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }